import React from 'react';

import Layout from 'layouts/Layout';
import Client from './Client';

const ClientLayout = ({ match }) => <Layout component={Client} match={match} />;

export default ClientLayout;
